import { Box, Container, Heading } from '@hover/blueprint';
import React from 'react';
import styled from '@emotion/styled';
import { StaticImage } from 'gatsby-plugin-image';
import { SlickSliderContainer } from '../../ui';
import CustomerQuoteInfo from './CustomerQuoteInfo';

const StyledSlider = styled(SlickSliderContainer)`
  .slick-dots li button:before {
    color: #e9e9e9;
  }

  .slick-slide div div {
    display: flex !important;
  }

  .slick-dots {
    bottom: -20px;
  }

  @media (max-width: 834px) {
    .slick-dots {
      bottom: -50px;
    }
  }
`;

const settings = {
  dots: true,
  infinite: true,
  speed: 2500,
  autoplaySpeed: 10000,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  arrows: false,
};

const CUSTOMERS_QUOTE_DATA = [
  {
    header: 'Benson Property Restores Homes Faster with HOVER',
    quote:
      'The 3D model allows us to show the homeowner that their home can look even better than before once it’s restored. We can turn the overall negative experience of suffering home damage into a more hopeful one',
    name: 'Anne Benson',
    role: 'owner and president, benson property',
    image: (
      <StaticImage
        quality={100}
        placeholder="blurred"
        src="../../../assets/images/insurance_case_study_1.png"
        alt="customer quote"
        objectFit="contain"
      />
    ),
    logo: (
      <Box w="80px" h="40px">
        <StaticImage
          quality={100}
          placeholder="blurred"
          src="../../../assets/images/benson_property_logo.png"
          alt="customer quote"
          objectFit="contain"
        />
      </Box>
    ),
    id: 2,
  },
  {
    header: 'The Roof Strategist uses HOVER for a more efficient process ',
    quote:
      'When you use HOVER you have the roof measurements and 3D model ready for the adjuster while he or she is on-site assessing the damage of the home and putting together what is known as the scope of loss.',
    name: 'Adam Bensman',
    role: 'sales & Marketing consultant, The Roof Strategist',
    image: (
      <StaticImage
        quality={100}
        placeholder="blurred"
        src="../../../assets/images/insurance_case_study_2.png"
        alt="customer quote"
        style={{ maxWidth: 340 }}
        objectFit="contain"
      />
    ),
    logo: (
      <Box w="162px" h="43px">
        <StaticImage
          quality={100}
          placeholder="blurred"
          src="../../../assets/images/the_roof_logo.png"
          alt="customer quote"
          objectFit="contain"
        />
      </Box>
    ),
    id: 1,
  },
];

const InsuranceCustomerQuote: React.FC = () => (
  <Box
    mt={{ base: 700, tablet: 1000, desktop: 0 }}
    bg={{ base: 'neutral.0', desktop: 'brandTan.100' }}
    pt={{ base: 0, desktop: 1000 }}
    px={{ base: 500, tablet: '56px', desktop: 0 }}
    pb={{ base: 600, desktop: 0 }}
    w="100%"
  >
    <Container
      pt={{ base: 700, desktop: 0 }}
      pb={{ base: '82px', tablet: 1000 }}
      maxW="1200px"
      bg="brandTan.100"
      borderRadius={{ base: '8px', desktop: 0 }}
      shadow={{
        base: 'distance300',
        desktop: 'none',
      }}
    >
      <Box d={{ base: 'none', desktop: 'block' }} w="100%">
        <StyledSlider {...settings}>
          {CUSTOMERS_QUOTE_DATA.map(customer => (
            <Box
              display="flex !important"
              key={customer.id}
              alignItems="center"
              justifyContent="space-between"
              w="100%"
            >
              <Container
                ml={0}
                flexDir="column"
                alignItems="flex-start"
                maxW="730px"
                px={200}
              >
                <Heading size={700} marginBottom={900}>
                  {customer.header}
                </Heading>
                <CustomerQuoteInfo
                  name={customer.name}
                  body={customer.quote}
                  role={customer.role}
                />
                <Box ml={{ base: 1000, desktop: '58px' }}>{customer.logo}</Box>
              </Container>
              <Box pr={400}>{customer.image}</Box>
            </Box>
          ))}
        </StyledSlider>
      </Box>
      <Box d={{ base: 'block', desktop: 'none' }} w="100%">
        <StyledSlider {...settings}>
          {CUSTOMERS_QUOTE_DATA.map(customer => (
            <Container
              px={200}
              key={customer.id}
              flexDir="column"
              alignItems="center"
            >
              <Heading size={500} marginBottom={700}>
                {customer.header}
              </Heading>
              <Box maxW="370px" maxH="370px">
                {customer.image}
              </Box>
              <CustomerQuoteInfo
                mt={800}
                name={customer.name}
                body={customer.quote}
                role={customer.role}
              />
              <Box alignSelf="flex-start" ml={{ base: '60px', desktop: 700 }}>
                {customer.logo}
              </Box>
            </Container>
          ))}
        </StyledSlider>
      </Box>
    </Container>
  </Box>
);

export default InsuranceCustomerQuote;
